import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";
import {
  ControlDirection,
  ThreatPolicyAction,
} from "#src/services/endpoint/threatPrevention/enums";
import i18next from "i18next";

const fixedTFunc = i18next.getFixedT(
  null,
  "endpoint",
  "threatPrevention.table.filter"
);

export const websiteActionFilterItems: IFilterItemV2[] = [
  {
    key: "block",
    getLabel: () => fixedTFunc("action.block"),
    value: ThreatPolicyAction.BLOCK_DOMAIN,
  },
  {
    key: "allow",
    getLabel: () => fixedTFunc("action.allow"),
    value: ThreatPolicyAction.ALLOW_DOMAIN,
  },
];

export const ipActionFilterItems: IFilterItemV2[] = [
  {
    key: "block",
    getLabel: () => fixedTFunc("action.block"),
    value: ThreatPolicyAction.BLOCK_IP,
  },
  {
    key: "allow",
    getLabel: () => fixedTFunc("action.allow"),
    value: ThreatPolicyAction.ALLOW_IP,
  },
];

export const portActionFilterItems: IFilterItemV2[] = [
  {
    key: "block",
    getLabel: () => fixedTFunc("action.block"),
    value: ThreatPolicyAction.BLOCK_PORT,
  },
  {
    key: "allow",
    getLabel: () => fixedTFunc("action.allow"),
    value: ThreatPolicyAction.ALLOW_PORT,
  },
];

export const controlDirectionFilterItems: IFilterItemV2[] = [
  {
    key: "inbound",
    value: ControlDirection.INBOUND,
    getLabel: () => fixedTFunc("directions.inbound"),
  },
  {
    key: "outbound",
    value: ControlDirection.OUTBOUND,
    getLabel: () => fixedTFunc("directions.outbound"),
  },
];

export const controlStatusFilterItems: IFilterItemV2[] = [
  {
    key: "enabled",
    getLabel: () => fixedTFunc("status.enabled"),
    value: "1",
  },
  {
    key: "disabled",
    getLabel: () => fixedTFunc("status.disabled"),
    value: "0",
  },
];
